import { theme } from '~/theme';

export type ClassKey = 'root' | 'count' | 'disabled' | 'primary' | 'secondary';

export const useSxStyles = () => {
  return {
    root: {
      display: 'inline-block',
      padding: theme.spacing(),
      width: '100%',
      height: '100%',
    },
    count: {
      fontSize: '1.75rem',
    },
    disabled: {
      display: 'inline-block',
      padding: theme.spacing(),
      width: '100%',
      height: '100%',
      pointerEvents: 'none',
    },
    primary: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    secondary: {
      fontSize: '0.625rem',
    },
  };
};
